import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { api } from '../api/client';

const WAGE_TYPES = [
  { v: '', label: '— select —' },
  { v: 'open', label: 'Open shop' },
  { v: 'ca_prevailing', label: 'CA prevailing wage (DIR)' },
  { v: 'davis_bacon', label: 'Federal Davis-Bacon' },
  { v: 'nv_prevailing', label: 'NV prevailing wage' },
];

export function NewProject() {
  const nav = useNavigate();
  const [f, setF] = useState<Record<string, string>>({});
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);

  const set = (k: string) => (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) =>
    setF((prev) => ({ ...prev, [k]: e.target.value }));

  async function submit(e: React.FormEvent) {
    e.preventDefault();
    setError('');
    if (!f.name?.trim()) { setError('Project name is required.'); return; }
    setBusy(true);
    try {
      const created = await api.createProject(f);
      nav(`/projects/${created.id}`);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Failed to create project');
    } finally {
      setBusy(false);
    }
  }

  return (
    <div style={{ maxWidth: 720 }}>
      <h1>New Bid</h1>
      <p className="muted">Create the project workspace. After this, you'll upload documents — the AI reads them, you count.</p>
      <form className="card" onSubmit={submit}>
        <div className="field">
          <label htmlFor="name">Project name *</label>
          <input id="name" value={f.name ?? ''} onChange={set('name')} required />
        </div>
        <div className="grid" style={{ gridTemplateColumns: '1fr 1fr' }}>
          <div className="field"><label>Customer / Owner</label><input value={f.customer_name ?? ''} onChange={set('customer_name')} /></div>
          <div className="field"><label>General Contractor</label><input value={f.gc_name ?? ''} onChange={set('gc_name')} /></div>
          <div className="field"><label>Job address</label><input value={f.job_address ?? ''} onChange={set('job_address')} /></div>
          <div className="field"><label>GC contact</label><input value={f.gc_contact ?? ''} onChange={set('gc_contact')} /></div>
          <div className="field"><label>County</label><input value={f.county ?? ''} onChange={set('county')} /></div>
          <div className="field"><label>State</label><input value={f.state ?? ''} onChange={set('state')} /></div>
          <div className="field"><label>Bid date</label><input type="date" value={f.bid_date ?? ''} onChange={set('bid_date')} /></div>
          <div className="field">
            <label>Wage type</label>
            <select value={f.wage_type ?? ''} onChange={set('wage_type')}>
              {WAGE_TYPES.map((w) => <option key={w.v} value={w.v}>{w.label}</option>)}
            </select>
          </div>
          <div className="field"><label>Salesperson</label><input value={f.salesperson ?? ''} onChange={set('salesperson')} /></div>
          <div className="field"><label>Estimator</label><input value={f.estimator ?? ''} onChange={set('estimator')} /></div>
        </div>
        {error && <div className="error">{error}</div>}
        <div style={{ display: 'flex', gap: 10, marginTop: 8 }}>
          <button className="btn btn-primary" type="submit" disabled={busy}>{busy ? 'Creating…' : 'Create bid'}</button>
          <button className="btn btn-ghost" type="button" onClick={() => nav('/')}>Cancel</button>
        </div>
      </form>
    </div>
  );
}
